/****************************************************
 * Module Name:  addSettingsModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import SettingsProxy from "../../utility/proxy/manager/settingsProxy";
import Constants from "../../utility/constants";
import CircularProgress from "@mui/material/CircularProgress";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';

export default class AddSettingsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newkey: this.props.editOperation ? this.props.sourceData.settingkey : "",
      newvalue: this.props.editOperation
        ? this.props.sourceData.settingvalue
        : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.settingdescription
        : "",

      showError: false,

      validateSettingsPresentSpinner: false,
      showValidationMessage: false,
      settingsAvailable: true,

      keyValidationError: "",
      valueValidationError: "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      settingkey: this.state.newkey,
      settingvalue: this.state.newvalue,
      settingdescription: this.state.newdescription,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateSettingsPresent = (settingsEntered) => {
    if (!settingsEntered || settingsEntered.trim() === "") return;

    this.setState({
      validateSettingsPresentSpinner: true,
    });

    SettingsProxy.CheckSettingsAvailable(settingsEntered, (response) => {
      //if we got response that means settings is present at backend
      if (response) {
        //SettingsName already present
        this.setState({
          validateSettingsPresentSpinner: false,
          showValidationMessage: true,
          settingsAvailable: false,
        });
      } else {
        //SettingsName not available, so can be used
        this.setState({
          validateSettingsPresentSpinner: false,
          showValidationMessage: true,
          settingsAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (this.props.editOperation && this.state.newvalue.length === 0)
      return true;

    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage ||
        !this.state.settingsAvailable ||
        this.state.newvalue.length === 0
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add setting validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />
        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation ? "Edit Settings" : "Add New Settings"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Settings Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Key <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newkey}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          label="Key (required)"
                          placeholder="Enter key"
                          value={this.state.newkey}
                          autoFocus
                          onBlur={(e) =>
                            this.validateSettingsPresent(this.state.newkey)
                          }
                          onChange={(e) =>
                            this.setState({
                              newkey: e.target.value,
                              showValidationMessage: false,
                              keyValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Key Cannot be Empty",
                            })
                          }
                          helperText={this.state.keyValidationError}
                          error={this.state.keyValidationError.length > 0}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateSettingsPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.settingsAvailable ? (
                        <font color="green">Settings Key available</font>
                      ) : (
                        <font color="red">Settings Key not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Value <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Value (required)"
                        placeholder="Enter Value"
                        value={this.state.newvalue}
                        onChange={(e) =>
                          this.setState({
                            newvalue: e.target.value,
                            valueValidationError: Utility.CheckIsPresent(
                              e.target.value
                            )
                              ? ""
                              : "Value Cannot be Empty",
                          })
                        }
                        helperText={this.state.valueValidationError}
                        error={this.state.valueValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
